<template>
  <div>
    <div class="page">
      <Navbar />
      <div class="content">
        <slot />
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "../navbar";
import Footer from "../footer";
export default {
  components: {
    Navbar,
    Footer,
  },
};
</script>
<style lang="scss">
@import "../../assets/all";
</style>